import * as React from 'react';
import * as TreeTypeRepository from '../../Repository/TreeTypeRepository';
import * as ContractRepository from '../../Repository/ContractRepository';
import TreeForm from './TreeForm';
import Loader from '../../Component/Loader/Loader';
import { message, PageHeader, Result } from 'antd';
import { TreeData } from 'tree-wallet-client';
import { default as Page, PageProps } from '../../Component/Page/Page';
import { GlobalContext } from '../../Contexts/GlobalContext';
import { withReactRouter } from "../../Helper/HooksHelper";
import { Navigate } from 'react-router-dom';
import voca from "voca";
import { UserRoles } from "../../Repository/UserRepository";

interface FormPageState {
  treeData?: TreeData[];
  loading: boolean;
}

export const allowedRoles = [
  ContractRepository.roles.TreePlanter,
  UserRoles.CompensationProgram
];

class FormPage extends React.Component<PageProps, FormPageState> {
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>;

  constructor(props: PageProps) {
    super(props);

    this.state = {
      treeData: undefined,
      loading: true,
    };
  }

  async componentDidMount() {
    const { contract, user } = this.context;

    if (user && contract) {
      await TreeTypeRepository.getTreeTypesList({
        params: { contractId: contract && contract.id, userId: user.id },
        successCallback: (treeData: any) => {
          this.setState({ treeData: treeData, });
        },
        errorCallback: (error: any) => {
          message.error('There was an error: ' + error);
        }
      })
      this.setState({ loading: false });
    }
  }

  render() {
    const { contract, user } = this.context;
    const { treeData, loading } = this.state;
    const pageProps = { ...this.props, loading }

    if (!user) {
      return <Navigate to={"/login"} />
    }

    if (!contract) {
      return (
        <Page
          {...pageProps}
          title={voca.capitalize(user?.firstName)}
          loading={false}
          allowedRoles={allowedRoles}
        >
          <Result status="error" title={"No contract defined"} />
        </Page>
      );
    }

    return (
      <GlobalContext.Consumer>
        {({ contract, user }) => {
          return (
            <Page {...pageProps} title={voca.capitalize(user?.firstName)} allowedRoles={allowedRoles}>
              {!loading && user && contract
                ? <TreeForm 
                    user={user} 
                    treeData={treeData} 
                    contract={contract} 
                    isPlanterValidator={true} // Enable planter validator mode for all planters
                  />
                : <PageHeader className="site-page-header" title={<Loader />} />
              }
            </Page>
          )
        }}
      </GlobalContext.Consumer>
    );
  }
}

export default withReactRouter(FormPage);